import { fetch } from 'utils';

window.expandDeliveryMethods = function (button) {
    const container = button.closest('.delivery-methods');

    if (container.classList.contains('is-expanded')) return;

    const startHeight = getComputedStyle(container).height;

    container.classList.add('is-expanded');

    // Respect the user's reduced-motion preference.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const endHeight = getComputedStyle(container).height;
    const previousOverflow = container.style.overflow;

    container.style.overflow = 'hidden';

    const expansion = container.animate(
        [
            { height: startHeight },
            { height: endHeight }
        ],
        {
            duration: 350,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)'
        }
    );

    container.querySelectorAll('.delivery-method').forEach((method, index) => {
        if (index < 3) return;

        method.animate(
            [
                { opacity: 0, transform: 'translateY(6px)' },
                { opacity: 1, transform: 'translateY(0)' }
            ],
            {
                duration: 250,
                delay: Math.min((index - 3) * 35, 140),
                easing: 'ease-out',
                fill: 'backwards'
            }
        );
    });

    expansion.onfinish = expansion.oncancel = function () {
        container.style.overflow = previousOverflow;
    };
};